module.exports = [{
      plugin: require('D:/ubug/storybook/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"defaultLayouts":{"default":"D:\\ubug\\storybook\\src\\templates\\markdown-page.js"},"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-copy-linked-files"},{"resolve":"D:\\ubug\\storybook\\plugins\\remark-images\\index.js","options":{"showCaptions":true,"backgroundColor":"#fafafa","maxWidth":1035,"watermark":"D:\\ubug\\storybook/src/images/watermark.png","watermarkGravity":"southwest","watermarkBlend":"over"}},{"resolve":"D:\\ubug\\storybook\\plugins\\remark-embedder\\index.js"}],"extensions":[".mdx",".md",".markdown"]},
    },{
      plugin: require('D:/ubug/storybook/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/ubug/storybook/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('D:/ubug/storybook/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
